module.exports = __webpack_public_path__ + "static/media/Administración.8c521ee8.png";